import { Label } from "@xola/ui-kit";
import React, { ReactNode } from "react";
import { SelectionState } from "types";
import { TravelerMessage, TravelersSelector } from "./TravelersSelector";

interface RecipientsFieldProps {
    travelersList: TravelerMessage[];
    value: SelectionState;
    popoverParentId: string;
    onChange: (value: SelectionState) => void;
}

export const RecipientsField = ({ travelersList, value, popoverParentId, onChange }: RecipientsFieldProps) => (
    <div className="flex flex-col gap-2">
        <Label>Recipients</Label>
        <TravelersSelector
            value={value}
            travelersList={travelersList}
            popoverParentId={popoverParentId}
            onChange={onChange}
        />
    </div>
);

export const getDescription = (selectionState: SelectionState, travelerList: TravelerMessage[]): ReactNode => {
    const isOrganizer = selectionState.selected.length === 1 && travelerList[0]?.id === selectionState.selected[0];

    if (selectionState.all) {
        return "This message will be sent to all attendees in this reservation.";
    }
    if (isOrganizer) {
        return "This message will only be sent to the organizer of this reservation.";
    }
    if (selectionState.selected.length === 0) {
        return "At least one recipient must be selected";
    }

    if (selectionState.selected.length === 1) {
        const attendee = travelerList.find((t) => t.id === selectionState.selected[0]);
        if (attendee) {
            return (
                <>
                    This message will only be sent to attendee <var data-var="attendeeName">{attendee.name}</var>
                </>
            );
        }
    }

    return null;
};
